import React, {useRef, useState, useEffect, useContext} from 'react'
import BarSide from '../components/BarSide';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {Tooltip} from "react-bootstrap";
import axios from "../components/Axios"
import { useGetValueContext  } from "../auth/GetValueContext";
import BarSide2 from '../components/BarSide2';
import Accordionmain from '../components/Accordionmain';
import listLogo from "../assets/viewList.png"
import moreLogo from "../assets/more.png"
import infinateyLogo from "../assets/infin.png"
import { Link, useNavigate } from "react-router-dom";
import { KeywordContext } from "../auth/KeywordContext";

function Home() {
    const { creditsCount, setCreditsCount } = useGetValueContext();
    const isFetching = useRef(false);
    const userDataString = localStorage.getItem("userData");
    const userData = userDataString ? JSON.parse(userDataString) : null;
    const [recentKeyword, setRecentData] = useState(null);
    const [loadingSpecificCampaign, setLoadingSpecificCampaign] = useState(null);
    
    // NEW: Function to fetch only basic campaign info (lightweight)
    const fetchrecentKeywords = async (userId) => {
      const timestamp = new Date().getTime();
      try {
        // Updated route now returns only basic info (name + count)
        const response = await axios.get(`/api/latestuserkeywords/${userId}?_=${timestamp}`);
        setRecentData(response.data); // Now contains only basic info
        console.log("Recent campaigns loaded:", response.data);
      } catch (error) {
        console.error('Error fetching user keywords', error);
      }
    };

    // NEW: Function to load complete campaign data when clicked
    const loadCompleteKeywordData = async (campaignId, campaignName) => {
      setLoadingSpecificCampaign(campaignId);
      
      try {
        const response = await axios.get(`/api/getkeyworddata/${campaignId}?userId=${userData._id}`);
        
        // Now navigate with complete data
        handleNavigate(response.data);
        
      } catch (error) {
        console.error("Error loading campaign data:", error);
        alert("Failed to load campaign data. Please try again.");
      } finally {
        setLoadingSpecificCampaign(null);
      }
    };

    const fetchCredits = async () => {
        if (!isFetching.current) {
          isFetching.current = true;
          try {
            const timestamp = new Date().getTime();
            const url = `/api/user/credits/${userData?._id}?t=${timestamp}`;
            const response = await axios.get(url);
            console.log("Adnan main response is", response.data.credits)
            setCreditsCount(response.data.credits);
            await fetchrecentKeywords(userData?._id);

          } catch (error) {
            console.error('Error fetching credits', error);
          } finally {
            isFetching.current = false;
          }
        }
      };

      useEffect(() => {
        if (creditsCount === 0) {
          fetchCredits();
        }
      }, []);
      
      useEffect(() => {
        fetchrecentKeywords(userData?._id);
      }, []);

      const getNextRenewalDate = () => {
        const createdAt = creditsCount.createdAt instanceof Date ? creditsCount.createdAt : new Date(creditsCount.createdAt);
        const nextYear = createdAt.getFullYear() + 1;
        const nextRenewalDate = new Date(nextYear, createdAt.getMonth(), createdAt.getDate());
       
        return nextRenewalDate.toLocaleString('en-US', {
          month: 'short', 
          day: '2-digit', 
          year: 'numeric', 
          hour: '2-digit', 
          minute: '2-digit'
        });
      };

      const lifeTime = ["655e4ac2af5ec88f540e6ff2", "65671e501d93febeacf0f5ef", "65675b1c9aae3b322b57d7b1", "6584f59db968caf13695d8c4",
    "6595df49fe08ba5d070ed01a", "659432d95fe8068d8b05977a", "659428f25fe8068d8b059756", "6593ba1c11d91aed95a63f93", "6596509601f908df858fadeb",
  "6593384300cf718fce765252", "6593eded8f37902c10c153b4", "6592b4122293639a322d7725", "65909e7035bacd46af88236d", "659f5e6c0733c896dfdf1745", "659faaa4284e8c69695d8fd4", "659fe100fb40ea5941d59722",
"659fe100fb40ea5941d59722", "65971f6a6a5d7174f6ca2c9f", "65a001adbead6b1b3c47c6ab", "65a2718e940547ca882ab88f", "65a418172f3b7351612e203d", "65ae1096b297ce8102e70846",
"65ac8dab5767af6d37fff068", "65a7224bf2a4bb5e1d05d922", "65a51aeffefa9fcd91972434", "65a7224bf2a4bb5e1d05d922", "65ac8dab5767af6d37fff068", "65ae1096b297ce8102e70846", "65c81364773367852d1cf6ca", "65c81364773367852d1cf6ca", "65ec6c77645ced5fccd12c9b", "659a394881b8ee62227ffb33", 
"65f0a2350f01e5ff5dc1b8c6", "66099ab8b49d719e8f9235f7", "660a452eb49d719e8f932677", "661765a4426ce552a5bf6e65", "66176a3f426ce552a5bf6e84", "66178124426ce552a5bf6ed3", "6617f62769ab8c5518c8f9f1", "6591d3cc525ea61837a799e0", "6629096834db6c75cdd2b5e8", "662651467c5192ff8ea331fb",
"662253e3e02dfb4f977552b9", "65a3358f4e2858acf0cc6cb4", "661b7c8169ab8c5518caa8bb", "66178124426ce552a5bf6ed3", "6629848e34db6c75cdd50946", "668137003770dcb2aa8f6f6b", "65a3358f4e2858acf0cc6cb4", "664886c61ffae451314aa58b", "6629848e34db6c75cdd50946", "66176a3f426ce552a5bf6e84", "663a25a60fe8c929191e944d",
"663b83a87fcbf7e4d52271c1", "66945ba708ae47b4b7f53e20", "6629848e34db6c75cdd50946", "6695b125c11daa0b001626be", "663a25a60fe8c929191e944d", "66899dc73a3a28e47eddcaa0", "67318840693e29ecff327600", 
]; 

const lifeTimeEmails = ["lindsharp@gmail.com", "jane@janesails.com"];

const {  updateKeywordData  } = useContext(KeywordContext);
  const navigate = useNavigate();

// UPDATED: Now works with complete data (after loading)
const handleNavigate = (item) => {
  console.log(item, "item from handleNavigate")
  const updatedItemData = {
    ...item,
    keywordData: item.keywordData.map((keywordItem, index) => ({
      ...keywordItem,
      id: keywordItem.id || `uuid-${index}`
    }))
  };

  // Slice the keywordData array to contain only the first 150 objects
  const slicedKeywordData = updatedItemData.keywordData.slice(0, 150);

  // Update the item with sliced keywordData
  const itemWithSlicedKeywordData = {
      ...updatedItemData,
      keywordData: slicedKeywordData
  };

  // Store the item with sliced keywordData in local storage
  localStorage.setItem('temporaryKeywordData', JSON.stringify(itemWithSlicedKeywordData));

  console.log(updatedItemData, "updatedItemData from handleNavigate")
  updateKeywordData(updatedItemData);

  let path = item.mainSeedKeyword;
  // Check if the path is a full URL
  if (path.startsWith('http://') || path.startsWith('https://')) {
    // Create a URL object
    const url = new URL(path);
    // Extract hostname (domain name)
    path = url.hostname;

    // Remove 'www.' if present
    if (path.startsWith('www.')) {
        path = path.substring(4);
    }
  }

  // Replace special characters with hyphens for URL
  path = path.replace(/[^a-zA-Z0-9]/g, '-');
  
  // Navigate to keyword detail page
  navigate(`/keyword-detail/${path}`);
};

// NEW: Handle campaign click with loading state
const handleCampaignClick = (campaign) => {
  // If already has keywordData (complete), navigate directly
  if (campaign.keywordData && campaign.keywordData.length > 0) {
    handleNavigate(campaign);
  } else {
    // Load complete data first, then navigate
    loadCompleteKeywordData(campaign._id, campaign.mainSeedKeyword);
  }
};

  return (
    <>
   
   <main className="flex flex-nowrap overflow-y-scroll">

<BarSide2 />

<div className="flex-grow">
  <div className="container mx-auto p-4">
    <div className="flex flex-wrap -mx-2">
      <div className="w-1/2 px-2 mb-4 ">
        <div className="border border-gray-200 bg-white rounded-lg p-4">
        <div>
            <div className="welcome-text">Welcome</div>
            <div className="user-name">{userData && userData.firstName && userData.lastName 
    ? `${userData.firstName} ${userData.lastName}` 
    : "User"}</div>
            <hr className="my-3"/>

            <div className="account-details">
            <div className="detail-row">
              <div className="label">Keyword Credits</div>
              <div className="detail-group">
                <div className="value">
                  <img src={infinateyLogo} className='homapaherecent' alt='List View' />
                  </div>
              </div>
            </div>
            <div className="detail-row">
              <div className="label">Rank Tracker Credits</div>
              <div className="detail-group">
                <div className="value">{creditsCount.rankcredits}</div>
                <div className="label"> / 100</div>
              </div>
            </div>
            <div className="detail-row">
              <div className="label">Ads-On Credits</div>
              <div className="detail-group">
                <div className="value zeroAddOn">0</div>
                <div className="label"> / 0</div>
              </div>
            </div>
            <button type="button" className="btn btn-info w-100 btn-sm mt-3 .btn-info-custommain text-white">
              See plans
            </button>
            </div>
          </div>
        </div>
      </div>
      <div className="w-1/2 px-2 mb-4">
        <div className="border border-gray-200 bg-white rounded-lg p-4 customwidthrecent">
        <div >
            <div className="user-name keywords-name-list">Recent Keywords
            </div>

{/* UPDATED: Campaign items with loading states */}
{recentKeyword?.slice(0, 5).map((item) => (
        <div className="item-container border-b border-gray-200 flex justify-between items-center  h-13 ml-[-0.55rem] p-[0.625rem] cursor-pointer list-keyword-hover" key={item?._id}>
          <div className="item-content flex items-center">
            <span className="material-symbols-outlined text-gray-500 text-lg">
              <img src={listLogo} className='homapaherecent' alt='List View' />
            </span>
            <div className="item-text ml-2.5 font-medium text-sm truncate max-w-[250px] item-text-main" 
                 onClick={() => handleCampaignClick(item)}>
              {item.mainSeedKeyword}
              {loadingSpecificCampaign === item._id && (
                <span className="ml-2 text-xs text-blue-500">Loading...</span>
              )}
            </div>
          </div>
          <div className="item-actions flex items-center">
            {/* UPDATED: Show keyword count from new backend response */}
            <div className="item-count text-gray-500 mr-3.75">
              {item.keywordCount || item.keywordData?.length || 0}
            </div>
            <a className="icon-btn">
              <span className="material-symbols-outlined text-gray-500 text-lg">
              <img src={moreLogo} className='homapaherecent' alt='more View' />
              </span>
            </a>
          </div>
        </div>
      ))}

      {/* Show loading state or empty state */}
      {!recentKeyword && (
        <div className="text-center py-4 text-gray-500">
          <div className="text-sm">Loading recent campaigns...</div>
        </div>
      )}

      {recentKeyword && recentKeyword.length === 0 && (
        <div className="text-center py-4 text-gray-500">
          <div className="text-sm">No campaigns found.</div>
          <div className="text-xs mt-1">Create your first keyword research!</div>
        </div>
      )}

            </div>

        </div>
      </div>
      {/* Faq */}
      <div className='px-2 my-4'>
      <div className="box-border  bg-[#f8fafc] border border-[#e2e8f0] rounded-2xl w-full p-0 pb-6 flex flex-col gap-8">
            <div className="border-b border-[#e2e8f0]">
                <div className="flex flex-row items-center py-3 px-8 bg-white rounded-t-2xl">
                    <p className="text-2xl font-semibold">
                        <b className='helptitle'>Begin Your Journey</b> <span className='helptext'>| We're here to help!</span>
                    </p>
                </div>
            </div>
            <div className="flex flex-col md:flex-row md:ml-8 md:pb-8 gap-8">
                {/* FAQ Card */}
                <div className="bg-white border border-[#e2e8f0] rounded-2xl flex flex-col  gap-8 w-full md:w-1/3">
                    <iframe width="100%" height="330px" className="z-10 rounded-2xl" src="https://www.youtube.com/embed/YploGr9ejCs?si=Vafo9rL9I_PebCt9" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                </div>

                {/* Questions */}
                <div className="flex flex-col gap-5 w-full md:w-2/3 pr-4">
                      <Accordionmain />
                </div>
            </div>
        </div></div>
      {/* Faq */}
    </div>
  </div>
</div>

</main>

 
    </>
  )
}

export default Home